"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            FilterManager_BlankAria: "Empty",
            FilterManager_ColumnFilterOpened: "Column filter opened.",
            FilterManager_FilterCountAria: "{0} filters:",
            FilterManager_FilterFieldDescriptionAria: " {0} {1} {2}.",
            FilterManager_FilterValueSeparator: "/",
            FilterManager_SortedAscendingAria: "Sorted ascending.",
            FilterManager_SortedDescendingAria: "Sorted descending.",
            FilterManager_UnsortedAria: "Unsorted."
        }
    });
    var controls;
    (function (controls) {
        var FilterManager = /** @class */ (function (_super) {
            __extends(FilterManager, _super);
            function FilterManager() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            /**
             * Calls the ApplyFilters command.
             * @internal
             * @param filters The filters to apply
             * @param controlName The name of the column control that is being filtered on.
             * @param telemetryActionEvents The type of telemetry action event
             */
            FilterManager.prototype.applyFieldFilters = function (filters, controlName, telemetryActionEvents) {
                var _this = this;
                var telemetryOptions;
                var filterOptions = [];
                filters.forEach(function (filter) {
                    if (telemetryActionEvents) {
                        if ($dyn.util.isFieldExpressionValueEmpty(filter.Values)) {
                            telemetryOptions = { userDefined1: 0, extendedData: filter.DataSourceName + ";" + filter.FieldName };
                        }
                        else {
                            var operator = $dyn.util.filterOperator2Int($dyn.value(filter.Operator));
                            telemetryOptions = { userDefined1: 1, userDefined2: operator, extendedData: filter.DataSourceName + ";" + filter.FieldName };
                        }
                        _this.telemetryEventArgs = $dyn.telemetry.addControlActionEvent(_this, _this.telemetryEventArgs, telemetryActionEvents, telemetryOptions);
                    }
                    // unwrap the filter values first as Values is tentialObservableArray<PotentialObservable<string>>
                    var unWrappedValues = [];
                    $dyn.value(filter.Values).forEach(function (value) {
                        unWrappedValues.push($dyn.value(value));
                    });
                    filterOptions.push({
                        fieldLabel: $dyn.value($dyn.value(filter.Capability).FieldLabel),
                        operatorLabel: $dyn.value($dyn.value(filter.Capability).OperatorLabel),
                        values: $dyn.value(unWrappedValues).join("/")
                    });
                });
                if ($dyn.value($dyn.ax.taskRecording.isRecording())) {
                    $dyn.callFunction(this.ApplyFilters, this, [filters, controlName, "", filterOptions]);
                }
                else {
                    $dyn.callFunction(this.ApplyFilters, this, [filters]);
                }
            };
            /**
             * Calls the GetFilters command.
             * @param dataSourceAndFieldNameArray A collection of datasourceName and fieldName pairs.
             * @param controlName The name of the column control that is being filtered on.
             * @param columnLabel The label of the column control that is being filtered on.
             * @param callback The callback from the command.
             */
            FilterManager.prototype.getFieldFilters = function (dataSourceAndFieldNameArray, controlName, columnLabel, callback) {
                if ($dyn.value($dyn.ax.taskRecording.isRecording())) {
                    $dyn.callFunction(this.GetFilters, this, [dataSourceAndFieldNameArray, controlName, columnLabel], callback);
                }
                else {
                    $dyn.callFunction(this.GetFilters, this, [dataSourceAndFieldNameArray], callback);
                }
            };
            FilterManager.prototype.getTaskGuideParams = function (options) {
                var actionHandler = {
                    "Command:ApplyFiltersForTaskRecorder": applyFilters,
                    "Command:GetFilters": getFilters,
                    "Command:ResetFilterCollectionForTaskRecorder": resetFilter,
                    "Command:SetSortsForTaskRecorder": setSorts
                };
                var actionHandlerFunc = actionHandler[options.action];
                if (!actionHandlerFunc) {
                    return _super.prototype.getTaskGuideParams.call(this, options);
                }
                actionHandlerFunc();
                return options;
                //
                // Implementation
                //
                function applyFilters() {
                    var controlName = options.arguments[2];
                    var $columnHeaderPopup = $('[data-dyn-form-name="' + controlName + '"].columnHeader-popup');
                    options.target = $columnHeaderPopup;
                    options.my = $dyn.layout.qTipPosition.rightCenter;
                    options.at = $dyn.layout.qTipPosition.leftCenter;
                }
                function getFilters() {
                    var controlName = options.arguments[1];
                    var currentForm = $dyn.shell.getActiveForm();
                    if (currentForm && currentForm.querySelector) {
                        var controlQuerySelector = currentForm.querySelector('[data-dyn-columnname="' + controlName + '"]');
                        if (controlQuerySelector && controlQuerySelector.querySelector) {
                            var columnHeaderWrapper = controlQuerySelector.querySelector(".columnHeaderWrapper");
                            options.target = $(columnHeaderWrapper);
                        }
                    }
                    options.my = $dyn.layout.qTipPosition.bottomCenter;
                    options.at = $dyn.layout.qTipPosition.topCenter;
                }
                function resetFilter() {
                    var controlName = options.arguments[2];
                    var $resetButton = $('[data-dyn-controlname="' + controlName + '_ResetFilters"]');
                    options.target = $resetButton;
                    options.my = $dyn.layout.qTipPosition.topCenter;
                    options.at = $dyn.layout.qTipPosition.bottomCenter;
                }
                function setSorts() {
                    var controlName = options.arguments[4];
                    var isAscending = options.arguments[1] === "1";
                    var $sortButton = isAscending
                        ? $('[data-dyn-controlname="Ascending_' + controlName + '"]')
                        : $('[data-dyn-controlname="Descending_' + controlName + '"]');
                    options.target = $sortButton;
                    options.my = $dyn.layout.qTipPosition.rightCenter;
                    options.at = $dyn.layout.qTipPosition.leftCenter;
                }
            };
            /**
             * Calls the ResetFilterCollection command.
             * @internal
             * @param dataSourceAndFieldNameArray A collection of datasourceName and fieldName pairs.
             * @param controlName The name of the column control that is having its filters reset.
             * @param telemetryActionEvents The type of telemetry action event.
             */
            FilterManager.prototype.resetFieldFilters = function (dataSourceAndFieldNameArray, controlName, telemetryActionEvents) {
                var _this = this;
                if (telemetryActionEvents) {
                    dataSourceAndFieldNameArray.forEach(function (dataSourceAndFieldName) {
                        var options = { userDefined1: 2, extendedData: dataSourceAndFieldName.DataSourceName + ";" + dataSourceAndFieldName.FieldName };
                        _this.telemetryEventArgs = $dyn.telemetry.addControlActionEvent(_this, _this.telemetryEventArgs, telemetryActionEvents, options);
                    });
                }
                if ($dyn.value($dyn.ax.taskRecording.isRecording())) {
                    $dyn.callFunction(this.ResetFilterCollection, this, [dataSourceAndFieldNameArray, controlName]);
                }
                else {
                    $dyn.callFunction(this.ResetFilterCollection, this, [dataSourceAndFieldNameArray]);
                }
            };
            FilterManager.prototype.setFieldSorts = function (sort, telemetryActionEvents, callback) {
                if (telemetryActionEvents) {
                    var extendedData_1 = "";
                    var fieldFilterExpressions = sort[0];
                    fieldFilterExpressions.forEach(function (dataSourceAndFieldName) {
                        extendedData_1 = dataSourceAndFieldName.DataSourceName + "." + dataSourceAndFieldName.FieldName + ";";
                    });
                    var telemetryEventData = parseInt(sort[2], 10);
                    var options_1 = { userDefined1: telemetryEventData, extendedData: extendedData_1 };
                    this.telemetryEventArgs = $dyn.telemetry.addControlActionEvent(this, this.telemetryEventArgs, telemetryActionEvents, options_1);
                }
                // The check for isRecording is in the caller of this (setFieldSorts) function.
                $dyn.callFunction(this.SetSorts, this, sort, callback);
            };
            FilterManager.prototype.removeFieldSorts = function (sort) {
                $dyn.callFunction(this.RemoveSorts, this, [sort]);
            };
            return FilterManager;
        }($dyn.ui.Container));
        controls.FilterManager = FilterManager;
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=FilterManager.js.map
